import {useMutation} from '@tanstack/react-query';
import {lkApi} from 'api';
import {useCallback} from 'react';

type Params = {
    /** проверка смс прошла успешно */
    onVerifySmsCodeSuccess?: (verificationToken: string) => void;

    /** ошибка при проверке смс */
    onVerifySmsCodeError?: () => void;

    /** запрос смс прошел успешно */
    onRequestSmsCodeSuccess?: () => void;

    /** ошибк при запросе смс */
    onRequestSmsCodeError?: () => void;
};

export function useVerificationPhone({
    onVerifySmsCodeSuccess,
    onVerifySmsCodeError,
    onRequestSmsCodeSuccess,
    onRequestSmsCodeError,
}: Params = {}) {
    const {mutate: sendSmsMutation, data: sendSmsData} = useMutation({
        mutationFn: lkApi.sendSms,
        onSuccess: onRequestSmsCodeSuccess,
        onError: onRequestSmsCodeError,
    });

    const {
        mutate: verifySmsCodeMutation,
        isError: verifySmsCodeIsError,
        isPending: verifySmsCodeIsPending,
        reset: verifySmsCodeMutationReset,
    } = useMutation({
        mutationFn: lkApi.verifySmsCode,
        onSuccess: (data) => onVerifySmsCodeSuccess?.(data.verification_token),
        onError: onVerifySmsCodeError,
    });

    const handleVerifySmsCode = useCallback(
        (code: string) => {
            if (sendSmsData?.send_token) {
                verifySmsCodeMutation({
                    code,
                    sendToken: sendSmsData.send_token,
                });
            }
        },
        [sendSmsData, verifySmsCodeMutation],
    );

    const handleSendSms = useCallback(
        (phone: string) => {
            verifySmsCodeMutationReset();
            // если уже есть токен, значит запрос смс уже был и повторные
            // смс нужно запрашивать по токену
            // if (sendSmsData?.send_token) {
            //     sendSmsMutation({sendToken: sendSmsData.send_token});
            // } else {
            //     const formattedPhone = phone.replace(/\s/g, '');
            //     sendSmsMutation({phone: formattedPhone});
            // }
            const formattedPhone = phone.replace(/\s/g, '');
            sendSmsMutation({phone: formattedPhone});
        },
        [sendSmsMutation, verifySmsCodeMutationReset],
    );

    return {
        verifySmsCodeIsError,
        verifySmsCodeIsPending,
        handleSendSms,
        verifySmsCode: handleVerifySmsCode,
        verifySmsCodeMutationReset,
    };
}
